/* eslint-disable @typescript-eslint/no-shadow */
export const NO_GROUP = 'internal-name-to-represent-no-group-name';
export const ANY_NODE_STRING = 'any_node';
export const FILE_UPLOAD_MAX_DEFAULT = 5368709120;
export var SYSTEM_COMMANDS;
(function (SYSTEM_COMMANDS) {
    SYSTEM_COMMANDS["HANDLE_BOT_ERROR"] = "HandleBotError";
})(SYSTEM_COMMANDS || (SYSTEM_COMMANDS = {}));
export var VALID_INTENTS;
(function (VALID_INTENTS) {
    VALID_INTENTS["OUT_OF_SCOPE"] = "out_of_scope";
})(VALID_INTENTS || (VALID_INTENTS = {}));
export var VALID_BEHAVIORS;
(function (VALID_BEHAVIORS) {
    VALID_BEHAVIORS["MULTIPLE_CHOICE"] = "multiple_choice";
    VALID_BEHAVIORS["DISABLE_INPUT"] = "disable_input";
    VALID_BEHAVIORS["XFER_TO_AGENT"] = "xfer_to_agent";
    VALID_BEHAVIORS["INLINE"] = "inline";
    VALID_BEHAVIORS["OUT_OF_SCOPE"] = "out_of_scope";
    VALID_BEHAVIORS["VOICE_ENABLE_BARGE_IN"] = "voice_enable_barge_in";
})(VALID_BEHAVIORS || (VALID_BEHAVIORS = {}));
export const SYSTEM_NODES = {
    HYPERSPACE_AGENT_NODE: '-1800',
    HYPERSPACE_END_NODE: '-212',
    BACK_NODE: '-537',
    HYPERSPACE_STARTOVER_NODE: '-929',
    END_CHAT_HANDLER_NODE: '-585',
    PERSISTENT_MENU_NODE: '-411',
    ERROR_HANDLER_NODE: '-500',
    EXIT_FLOW_NODE: '-617',
};
export const SYSTEM_RESERVED_GLOBALS = ['SKILL_TAGS'];
/**
 * Set of all keyword strings that should be extracted from quoted terminals.
 * These keywords are used in KeywordsFragment and should have quotes stripped.
 */
export const KEYWORD_STRINGS = new Set([
    // Rich asset types
    '"audio"',
    '"button"',
    '"buttons"',
    '"carousel"',
    '"datepicker"',
    '"deeplink"',
    '"document"',
    '"file_upload"',
    '"imagebutton"',
    '"image"',
    '"listpicker"',
    '"location"',
    '"none"',
    '"persistent_menu"',
    '"png"',
    '"quick_reply"',
    '"secure"',
    '"selection"',
    '"star"',
    '"timepicker"',
    '"video"',
    '"webview"',
    // Node and field keywords
    '"nodeNumber"',
    '"nodeType"',
    '"nodeName"',
    '"nextNodes"',
    '"message"',
    '"answerRequired"',
    '"behaviors"',
    '"command"',
    '"description"',
    '"output"',
    '"nodeInput"',
    '"parameterInput"',
    '"decisionVariable"',
    '"whatsNext"',
    '"intent"',
    '"nluDisabled"',
    '"nodeTags"',
    '"skillTag"',
    '"variables"',
    '"platformFlag"',
    '"utterances"',
    '"flows"',
    '"cssClassName"',
    '"groupName"',
    '"groupOrder"',
    '"id"',
    '"event"',
    '"richAsset"',
    '"type"',
    '"alt_text"',
    '"dest"',
    '"static"',
    '"dynamic"',
    '"label"',
    '"url"',
    '"loop"',
    '"source_node"',
    '"source_var"',
    '"content"',
    '"send"',
    '"event_name"',
    '"hide-user-text"',
    '"hide-app-text"',
    '"additional_properties"',
    '"global_props"',
    '"global_props_unset"',
    '"retention_days"',
    '"options"',
    '"icon_prefix"',
    '"icon_suffix"',
    '"vars"',
    '"variable"',
    '"value"',
    '"title"',
    '"subtitle"',
    '"opt_text"',
    '"additional_cta"',
    '"ios_url"',
    '"android_url"',
    '"ios_store"',
    '"android_store"',
    '"upload_label"',
    '"cancel_label"',
    '"endpoint"',
    '"action_script"',
    '"headers"',
    '"set_value"',
    '"cta_label"',
    '"inline"',
    '"close_message"',
]);
export var NODE_TYPE;
(function (NODE_TYPE) {
    NODE_TYPE["D"] = "D";
    NODE_TYPE["A"] = "A";
})(NODE_TYPE || (NODE_TYPE = {}));
export var RICH_ASSET_TYPE;
(function (RICH_ASSET_TYPE) {
    RICH_ASSET_TYPE["None"] = "none";
    RICH_ASSET_TYPE["Audio"] = "audio";
    RICH_ASSET_TYPE["Button"] = "button";
    RICH_ASSET_TYPE["Buttons"] = "buttons";
    RICH_ASSET_TYPE["Carousel"] = "carousel";
    RICH_ASSET_TYPE["Datepicker"] = "datepicker";
    RICH_ASSET_TYPE["Deeplink"] = "deeplink";
    RICH_ASSET_TYPE["Document"] = "document";
    RICH_ASSET_TYPE["FileUpload"] = "file_upload";
    RICH_ASSET_TYPE["Image"] = "image";
    RICH_ASSET_TYPE["Imagebutton"] = "imagebutton";
    RICH_ASSET_TYPE["Listpicker"] = "listpicker";
    RICH_ASSET_TYPE["Location"] = "location";
    RICH_ASSET_TYPE["LoginButton"] = "login_button";
    RICH_ASSET_TYPE["PersistentMenu"] = "persistent_menu";
    RICH_ASSET_TYPE["Png"] = "png";
    RICH_ASSET_TYPE["QuickReply"] = "quick_reply";
    RICH_ASSET_TYPE["Secure"] = "secure";
    RICH_ASSET_TYPE["Selection"] = "selection";
    RICH_ASSET_TYPE["Star"] = "star";
    RICH_ASSET_TYPE["TimePicker"] = "timepicker";
    RICH_ASSET_TYPE["Video"] = "video";
    RICH_ASSET_TYPE["Webview"] = "webview";
})(RICH_ASSET_TYPE || (RICH_ASSET_TYPE = {}));
export var FRONTEND_PROPERTY_NAME;
(function (FRONTEND_PROPERTY_NAME) {
    FRONTEND_PROPERTY_NAME["NODE_NUMBER"] = "nodeNumber";
    FRONTEND_PROPERTY_NAME["NODE_TYPE"] = "nodeType";
    FRONTEND_PROPERTY_NAME["NODE_NAME"] = "nodeName";
    FRONTEND_PROPERTY_NAME["INTENT"] = "intent";
    FRONTEND_PROPERTY_NAME["NLU_DISABLED"] = "nluDisabled";
    FRONTEND_PROPERTY_NAME["NEXT_NODES"] = "nextNodes";
    FRONTEND_PROPERTY_NAME["MESSAGE"] = "message";
    FRONTEND_PROPERTY_NAME["RICH_ASSET_TYPE"] = "richAssetType";
    FRONTEND_PROPERTY_NAME["RICH_ASSET_CONTENT"] = "richAssetContent";
    FRONTEND_PROPERTY_NAME["ANSWER_REQUIRED"] = "answerRequired";
    FRONTEND_PROPERTY_NAME["BEHAVIORS"] = "behaviors";
    FRONTEND_PROPERTY_NAME["COMMAND"] = "command";
    FRONTEND_PROPERTY_NAME["DESCRIPTION"] = "description";
    FRONTEND_PROPERTY_NAME["OUTPUT"] = "output";
    FRONTEND_PROPERTY_NAME["NODE_INPUT"] = "nodeInput";
    FRONTEND_PROPERTY_NAME["PARAMETER_INPUT"] = "parameterInput";
    FRONTEND_PROPERTY_NAME["DECISION_VARIABLE"] = "decisionVariable";
    FRONTEND_PROPERTY_NAME["WHATS_NEXT"] = "whatsNext";
    FRONTEND_PROPERTY_NAME["NODE_TAGS"] = "nodeTags";
    FRONTEND_PROPERTY_NAME["SKILL_TAG"] = "skillTag";
    FRONTEND_PROPERTY_NAME["VARIABLES"] = "variables";
    FRONTEND_PROPERTY_NAME["PLATFORM_FLAG"] = "platformFlag";
    FRONTEND_PROPERTY_NAME["UTTERANCES"] = "utterances";
    FRONTEND_PROPERTY_NAME["FLOWS"] = "flows";
    FRONTEND_PROPERTY_NAME["CSS_CLASS_NAME"] = "cssClassname";
    FRONTEND_PROPERTY_NAME["GROUP_NAME"] = "groupName";
    FRONTEND_PROPERTY_NAME["GROUP_ORDER"] = "groupOrder";
    FRONTEND_PROPERTY_NAME["EVENT"] = "event";
    FRONTEND_PROPERTY_NAME["ID"] = "id";
})(FRONTEND_PROPERTY_NAME || (FRONTEND_PROPERTY_NAME = {}));
//# sourceMappingURL=constants.js.map